// removed by extract-text-webpack-plugin
module.exports = {"autocompleteContainer":"_21EC_NfsWKGTCQYdldqAyf","autocompleteItem":"_364wDyKuc0WnXfbSk_atar","autocompleteItemActive":"_2XWF0_miEWZLyErQC2XTN4","suggestionItem":"_1kFQSo1Hb4aEZBmxypTBGo","footer":"_1nBFsqX4Fr2hgW22nfhFal"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/forms/VenueField.scss
// module id = 1252
// module chunks = 0